<div class="d-flex justify-content-between dialog-title">
  <div>
    <p class="mb-0 mt-1 dialog-title">OrderCart</p>
  </div>
  <div>
    <button [mat-dialog-close]="true" mat-icon-button>
      <mat-icon class="dialog-icon">close</mat-icon>
    </button>
  </div>
</div>
<app-pos-cart [sectionId]="data.sectionId" (orderPrinted)="onOrderCheckOut($event)"></app-pos-cart>
